module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/frontmatter02#ca",
      "id": "ta"
    }
  }, [_vm._v("Foreword by Dr. Michael Kailas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter03#cb",
      "id": "tb"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter04#cc",
      "id": "tc"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#c1",
      "id": "t1"
    }
  }, [_vm._v("Chapter 1: Everything’s Blurry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#c2",
      "id": "t2"
    }
  }, [_vm._v("Chapter 2: Paramedics Don’t Always Rush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#c3",
      "id": "t3"
    }
  }, [_vm._v("Chapter 3: No. I Mean, Yes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#c4",
      "id": "t4"
    }
  }, [_vm._v("Chapter 4: Unthinkable Odds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c5",
      "id": "t5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Calling the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#c6",
      "id": "t6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Breathe, David, Breathe!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#c7",
      "id": "t7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Squeeze Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#c8",
      "id": "t8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Over the River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#c9",
      "id": "t9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: What a Mess!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c10",
      "id": "t10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Packing for Uncertainty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c11",
      "id": "t11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Hearths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c12",
      "id": "t12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Rip Van Winkle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#c13",
      "id": "t13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Campuses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#c14",
      "id": "t14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Surprises")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#c15",
      "id": "t15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Emotional Roller Coaster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#c16",
      "id": "t16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Third Time’s a Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#c17",
      "id": "t17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Phew!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#c18",
      "id": "t18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Colorful Roommate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#c19",
      "id": "t19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Befriending the Staff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter20#c20",
      "id": "t20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Catching Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#c21",
      "id": "t21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: “Don’t Worry” Means “Worry”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#c22",
      "id": "t22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: “I Love You!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#c23",
      "id": "t23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Music for Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#c24",
      "id": "t24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: ETR (Expected Time for Recovery)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#c25",
      "id": "t25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Close Living Wears Thin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#c26",
      "id": "t26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Prisoners without Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#c27",
      "id": "t27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: April Fool’s Joke?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#c28",
      "id": "t28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Barely Staying Sane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#c29",
      "id": "t29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Betty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#c30",
      "id": "t30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: An Invitation to Speak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#c31",
      "id": "t31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: Open-air Gym")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#c32",
      "id": "t32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Definitely Not a Vacation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#c33",
      "id": "t33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Kristin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#c34",
      "id": "t34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Parade of Helpers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#c35",
      "id": "t35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Angela")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#c36",
      "id": "t36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Returning to Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#c37",
      "id": "t37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: Monique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#c38",
      "id": "t38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: Rocky Look-alike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#c39",
      "id": "t39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: Wind River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#c40",
      "id": "t40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: Invisible TBI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#c41",
      "id": "t41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41: New Normal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01#c42",
      "id": "t42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#c43",
      "id": "t43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword by David Figurski")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03#c44",
      "id": "t44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter04#c45",
      "id": "t45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter05#c46",
      "id": "t46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 69
// module chunks = 0